import { AgeSurchargeType, Currency } from "@/gql/graphql";
import { formatCurrency } from "@/lib/Formatters/formatCurrency";

export function AgeSurchargeIndicator({
  minimumAge,
  maximumAge,
  minimumNoSurchargeAge,
  maximumNoSurchargeAge,
  ageSurchargeAmount,
  ageSurchargeType,
  currency,
  className,
}: {
  minimumAge: number;
  maximumAge: number;
  minimumNoSurchargeAge: number;
  maximumNoSurchargeAge: number;
  ageSurchargeAmount: number;
  ageSurchargeType: AgeSurchargeType;
  currency: Currency;
  className?: string;
}) {
  const surchargeLabel = getLabel(
    ageSurchargeType,
    ageSurchargeAmount,
    currency,
  );

  return (
    <div className={className}>
      <div className="grid grid-cols-12 overflow-hidden rounded-lg">
        <div className="col-span-1 h-8 bg-red-500"></div>
        <div className="col-span-2 flex h-8 items-center justify-center bg-yellow-500 px-2">
          <span className="text-xs font-medium text-yellow-900">
            {surchargeLabel}
          </span>
        </div>
        <div className="col-span-6 flex h-8 items-center justify-center bg-green-500 px-3">
          <span className="text-xs font-medium text-green-900">
            No surcharge
          </span>
        </div>
        <div className="col-span-2 flex h-8 items-center justify-center bg-yellow-500 px-2">
          <span className="text-xs font-medium text-yellow-900">
            {surchargeLabel}
          </span>
        </div>
        <div className="col-span-1 h-8 bg-red-500"></div>
      </div>
      <div className="mt-2 grid grid-cols-12 text-xs text-gray-600">
        <div className="col-span-1 py-1 text-center">
          {"<"}
          {minimumAge}
        </div>
        <div className="col-span-2 py-1 text-center">
          {"<"}
          {minimumNoSurchargeAge}
        </div>
        <div className="col-span-6 py-1 text-center">
          {minimumNoSurchargeAge} - {maximumNoSurchargeAge}
        </div>
        <div className="col-span-2 py-1 text-center">
          {">"}
          {maximumNoSurchargeAge}
        </div>
        <div className="col-span-1 py-1 text-center">
          {">"}
          {maximumAge}
        </div>
      </div>
    </div>
  );
}

function getLabel(
  type: AgeSurchargeType,
  amount: number,
  currency: Currency,
): string {
  if (type === AgeSurchargeType.Unspecified) return "";

  if (type === AgeSurchargeType.PerDay) {
    return `${formatCurrency(amount, currency)}/day`;
  }

  return formatCurrency(amount, currency);
}
